import React from 'react'
import './help-section-slider.pure.css'

const HelpSectionSliderFaqItemPure = (props) => {
    const { faq, stateList, toggleHelpSectionQuestionAnswer } = props
    return (
        <div>
            <div className="helpSecionPanel-content-div-faq" onClick={() => { toggleHelpSectionQuestionAnswer(faq, stateList) }}>
                <span className="helpSecionPanel-content-div-faq-icon"><i className="k-icon k-i-arrow-60-right" /></span>
                <p className="helpSecionPanel-content-div-faq-p-question">{faq.question}</p>
            </div>
            {faq.showFaqItem ? <p className="helpSecionPanel-content-div-faq-p-answer">{faq.answer}</p> : null}
        </div>
    )
}
export { HelpSectionSliderFaqItemPure as default }